module.exports = __webpack_public_path__ + "static/media/c.b8faf8d8.png";